export const getIsOnline = state => Boolean(state.network.status);



// WEBPACK FOOTER //
// ./src/selectors/network.js